import SingleValueSourceModel from '../SingleValueSourceModel';
import { getDefaultProps } from '../TextableModel';
import PropertyDescriptor from '../../utils/PropertyDescriptor';

export default class Model extends SingleValueSourceModel {

    constructor(opts = {}) {
        super();
        let defaultProps = getDefaultProps();
        for (let field in defaultProps) {
            this[field] = defaultProps[field];
            if (field === 'text') {
                this[field].visible = false;
            }
        }
        this.defineAllProperties();

        this.setVisible();
        this.backgroundColor = "transparent";
        this.borderWidth = 0;
        this.text = "数据文本框";

        for (var p in opts) {
            this[p] = opts[p];
        }
    }

    onPropertyValueChanged(name, oldVal, newVal, subName) {
        super.onPropertyValueChanged(name, oldVal, newVal, subName);
        if (['dataValue', 'singleValueMap', 'scriptService'].indexOf(name) > -1) {
            this.setText();
        }
    }
    setText() {
        let data = this.getData();
        this.text = data;
    }
    getType() {
        return "TextWithSourceModel";
    }
}
